import type { Outfit, OutfitInput, OutfitResponse, OutfitsResponse } from '../../shared/outfits';
import { readError } from './api';

export async function listOutfits(): Promise<Outfit[]> {
  const response = await fetch('/api/outfits', {
    credentials: 'include',
    headers: { Accept: 'application/json' },
  });
  if (!response.ok) throw new Error(await readError(response));
  return ((await response.json()) as OutfitsResponse).outfits;
}

export async function getOutfit(id: string): Promise<Outfit> {
  const response = await fetch(`/api/outfits/${encodeURIComponent(id)}`, {
    credentials: 'include',
    headers: { Accept: 'application/json' },
  });
  if (!response.ok) throw new Error(await readError(response));
  return ((await response.json()) as OutfitResponse).outfit;
}

export async function createOutfit(input: OutfitInput): Promise<Outfit> {
  return saveOutfit('/api/outfits', 'POST', input);
}

export async function updateOutfit(id: string, patch: Partial<OutfitInput>): Promise<Outfit> {
  return saveOutfit(`/api/outfits/${encodeURIComponent(id)}`, 'PATCH', patch);
}

async function saveOutfit(
  url: string,
  method: 'POST' | 'PATCH',
  body: OutfitInput | Partial<OutfitInput>,
): Promise<Outfit> {
  let response: Response;
  try {
    response = await fetch(url, {
      method,
      credentials: 'include',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    });
  } catch {
    throw new Error('Your connection dropped. Your outfit is still on the canvas—please retry.');
  }
  if (!response.ok) throw new Error(await readError(response));
  return ((await response.json()) as OutfitResponse).outfit;
}

export async function deleteOutfit(id: string): Promise<void> {
  const response = await fetch(`/api/outfits/${encodeURIComponent(id)}`, {
    method: 'DELETE',
    credentials: 'include',
    headers: { Accept: 'application/json' },
  });
  if (!response.ok) throw new Error(await readError(response));
}
